import module from "../helper/inject";

/** @type jQuery **/
const $ = module.$();

$(document).ready(() => {
   const dropdownContainer = $('[dropdown-container]');

   dropdownContainer.each(function () {
       const ref = $(this);
       const trigger = ref.find('[dropdown-trigger]');
       const dropdown = ref.find('[dropdown]');

       trigger.on('click', () => {
           ref.toggleClass('active');
           if (ref.hasClass('active')) {
               dropdown.slideDown();
           } else {
               dropdown.slideUp();
           }
       });
   })
});
